// extracted by mini-css-extract-plugin
export default {"wrapper":"Fc","centered":"Gc","gridWrapper":"Hc","grid":"Ic","oneColumn":"Jc"};